import { useNavigate, useLocation } from 'react-router-dom'
export function useBackNavigation(defaultPath: string = '/work') {
  const navigate = useNavigate()
  const location = useLocation()
  const goBack = () => {
    // If we have a "from" state, go back to that page
    if (location.state?.from) {
      navigate(location.state.from)
    } else {
      // Otherwise, use the provided default path
      navigate(defaultPath)
    }
  }
  return goBack
}
